export default "__VITE_ASSET__3d0c68cd__"